import { Link, useLocation, useNavigate } from "react-router-dom"
import Logo from "@/assets/logo-horizontal-orange.svg"
import { SidebarTrigger } from "../ui/sidebar"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { useChat } from "@/modules/Chat/context/ChatContext"
import gaiaLogo from "@/assets/gaia-logo.png"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"
import { Icon } from "../Atoms/Icon"
import { useState } from "react"
import { FeedbackModal } from "@/modules/Feedback/components/FeedbackModal"

export function MobileHeader() {
  const { pathname } = useLocation()
  const { user, logout } = useAuth()
  const { toggleChat } = useChat()
  const navigate = useNavigate()
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  return (
    <>
      <header className="sticky top-0 z-10 border-b border-border bg-background md:hidden">
        <div className="grid grid-cols-3 px-4 py-3">
          <SidebarTrigger />

          <Link
            to="/dashboard"
            className="flex items-center justify-center"
          >
            <img
              src={Logo}
              alt="Giants"
              className="h-7"
            />
          </Link>

          <div className="flex items-center justify-end gap-4">
            {/* {user.pesTipo === 3 && (
            <button onClick={toggleChat}>
              <img
                src={gaiaLogo}
                alt=""
                width="25"
              />
            </button>
          )} */}

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="text-zinc-400">
                  <Icon
                    name="circle-user"
                    state="elegant"
                    size={20}
                  />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="end"
                className="w-48"
              >
                <DropdownMenuLabel>Minha Conta</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  className="gap-2"
                  onClick={() => {
                    navigate("/profile")
                  }}
                >
                  <Icon
                    name="circle-user"
                    state="elegant"
                  />
                  Meu Perfil
                </DropdownMenuItem>
                {user.pesTipo === 3 && (
                  <DropdownMenuItem
                    className="gap-2"
                    onClick={() => {
                      navigate("/company-profile")
                    }}
                  >
                    <Icon
                      name="building"
                      state="elegant"
                    />
                    Perfil da Empresa
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem
                  className="gap-2"
                  onClick={() => {
                    setIsFeedbackModalOpen(true)
                  }}
                >
                  <Icon
                    name="skill-user"
                    state="elegant"
                  />
                  Enviar Feedback
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={handleLogout}
                  className="gap-2 text-red-400"
                >
                  <Icon
                    name="sign-out-alt"
                    state="elegant"
                  />
                  Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onOpenChange={setIsFeedbackModalOpen}
      />
    </>
  )
}
